import React, { useEffect, useState, useRef } from 'react'
import ModalMenu from './ModalMenu';
import circle from '../img/circulogris.png';
import { searchAction } from '../actions/searchActions'
import { connect } from 'react-redux';
import { getProfessionalUsers, addContact } from '../actions/contactsActions'
import searchIcon from '../img/ic__buscador.png'
import { resetInfo } from '../actions/userActions';


function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(
        initialIsVisible
    );
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            setIsComponentVisible(false);
        }
    };

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            if (isComponentVisible)
                event.stopPropagation()
            setIsComponentVisible(false);
        }
    };
    useEffect(() => {
        document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    })
    return { ref, isComponentVisible, setIsComponentVisible };
}

const ModalSearchBar = ({ history, searchAction, searchList, isLoading, resetInfo, isProfessionalUser, getProfessionalUsers, professionalList, isLoadingProfessional, addContact }) => {

    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);

    const [searchName, setSearchName] = useState('')

    useEffect(() => {
        getProfessionalUsers()
    }, [])


    const contentModal = isProfessionalUser ? <div className='scroll-menu modal-search-bar'>
        <div className="modal-results-search-bar">
            <div>
                {isLoadingProfessional ? <div></div> :
                    professionalList.filter(item => item.name && (item.name.toUpperCase().includes(searchName.toUpperCase()) || item.email && item.email.toUpperCase().includes(searchName.toUpperCase()))).map(user => {
                        return (
                            <div
                                className="column centerItems text-gray relative"
                                key={user._id}
                                onClick={() => {
                                    history.push("/Professional/Profile/" + user._id)
                                    setIsComponentVisible(false)
                                }}
                            >
                                {user.profilePicture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.profilePicture}></img> :
                                    <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                                }
                                {user.name}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div> : <div className='scroll-menu modal-search-bar'>
        <div className="modal-results-search-bar">
            <div>
                {isLoading ? <div></div> :
                    searchList && searchList.users.map((user) => (
                        <div
                            className="column centerItems"
                            key={user._id}
                            onClick={() => {
                                history.push('/Profile/' + user._id)
                                setIsComponentVisible(false)
                            }
                            } >
                            {user.picture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.picture.url ? user.picture.url.small : user.picture}></img> :
                                <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                            }
                            {user.name}
                        </div>
                    ))
                }
            </div>
        </div>
    </div >


    return (
        <div className="relative" style={{width:'100%', maxWidth:'500px'}} ref={ref}>
            <div
                className="modal-content-button-search-bar"
                onClick={() =>
                    setIsComponentVisible(true)
                }
            >
                <div className="search-bar-navbar navbar-searhbar">
                    <img src={searchIcon} alt="img" className="img-search-bar" />
                    {isProfessionalUser ?
                        <input type="text" onChange={e => setSearchName(e.target.value)} className="input-inside-div"></input>
                        :
                        <input type="text" onFocus={(e) => { searchAction(e.target.value) }} onChange={(e) => { searchAction(e.target.value) }} className="input-inside-div"></input>}
                </div>
            </div>
            {isComponentVisible &&
                contentModal
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        searchList: state.users.searchList,
        isLoading: state.users.isLoadingSearchList,
        professionalList: state.contacts.professionalList,
        isLoadingProfessional: state.contacts.isLoadingProfessionalList
    }
}

export default connect(mapStateToProps, { searchAction, getProfessionalUsers, addContact, resetInfo })(ModalSearchBar)
